import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Küsi lisainfot &lt;a href="mailto:info\@on24.ee?subject=Toote%20<span style="color:#a6d189;">**{toode}**</span>%20saadavus%3F"&gt;klienditeenindusest&lt;/a&gt;.

  <span style="color:#85c1dc;">**FI:**</span>
  Kysy lisätietoja &lt;a href="mailto:info\@on24.fi?subject=Tuotteen%20<span style="color:#a6d189;">**{toode}**</span>%3F"&gt;asiakaspalvelusta&lt;/a&gt;.

  <span style="color:#85c1dc;">**RU:**</span>
  Спроси дополнительную информацию &lt;a href="mailto:info\@ru.on24.ee?subject=%20<span style="color:#a6d189;">**{toode}**</span>%3F"&gt;доставки&lt;/a&gt;.
*/
/* @__NO_SIDE_EFFECTS__ */
const m162 = msg(
  mf`Küsi lisainfot <a href="mailto:info@on24.ee?subject=Toote%20${'toode'}%20saadavus%3F">klienditeenindusest</a>.`,
  mf`Kysy lisätietoja <a href="mailto:info@on24.fi?subject=Tuotteen%20${'toode'}%3F">asiakaspalvelusta</a>.`,
  mf`Спроси дополнительную информацию <a href="mailto:info@ru.on24.ee?subject=%20${'toode'}%3F">доставки</a>.`,
)

export { m162 as 'w.module.product.ask_details' }